import { createRouter, createWebHistory } from 'vue-router'

import HomePage from "@/components/HomePage.vue";
import ListRegions from "@/components/Regions/ListRegions.vue";
import CardRegions from "@/components/Regions/CardRegions.vue";
import ErrorPage from "@/components/ErrorPage.vue";
import OwnProgram from "@/components/Regions/OwnProgram.vue";
import ListAgreements from "@/components/Agreements/ListAgreements.vue";
import ListNpa from "@/components/Regulations/ListNpa.vue";
import CardNpa from "@/components/Regulations/CardNpa.vue";
import CardAgreement from "@/components/Agreements/CardAgreement.vue";
import CapitalizationEdit from "@/components/Capitalization/CapitalizationEdit.vue";
import CapitalizationView from "@/components/Capitalization/CapitalizationView.vue";
import ForbiddenPage from '@/components/ForbiddenPage.vue'
import NotFoundPage from '@/components/NotFoundPage.vue'
import ServerErrorPage from '@/components/ServerErrorPage.vue'

const router = createRouter({
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorPage
    },
    {
      path: "/403",
      name: "ForbiddenPage",
      component: ForbiddenPage
    },
    {
      path: "/404",
      name: "NotFoundPage",
      component: NotFoundPage
    },
    {
      path: "/500",
      name: "ServerErrorPage",
      component: ServerErrorPage
    },
    {
      path: "/regions",
      name: "ListRegions",
      component: ListRegions
    },
    {
      path: "/region/:id",
      name: "CardRegions",
      component: CardRegions,
      meta: {
        title: "Регионы"
      }
    },
    {
      path: "/region/:id/own",
      name: "AddOwnProgram",
      component: OwnProgram,
      meta: {
        title: "Регионы"
      }
    },
    {
      path: "/region/:id/own/:own",
      name: "EditOwnProgram",
      component: OwnProgram,
      meta: {
        title: "Регионы"
      }
    },
    {
      path: "/own-program-agreements",
      name: "ListAgreements",
      component: ListAgreements
    },
    {
      path: "/own-program-agreements/:id/add",
      name: "AddAgreement",
      component: CardAgreement
    },
    {
      path: "/own-program-agreements/:id/:program/:agreement",
      name: "EditAgreement",
      component: CardAgreement
    },
    {
      path: "/regulations",
      name: "ListNpa",
      component: ListNpa
    },
    {
      path: '/regulations/:region/:title',
      name: 'CardNpa',
      component: CardNpa,
      props: (route) => ({
        selectedRegion: route.params.region,
        title: route.params.title
      })
    },
    {
      path: '/regulations/add-new-npa/:region?',
      name: 'AddCardNpa',
      component: CardNpa,
      props: (route) => ({ selectedRegion: route.query.region || "" })
    },
    {
      path: '/capitalization/edit/:id',
      name: 'CapitalizationEdit',
      component: CapitalizationEdit,
      meta: {
        title: "Капитализация"
      }
    },
    {
      path: '/capitalization/view/:id',
      name: 'CapitalizationView',
      component: CapitalizationView,
      meta: {
        title: "Капитализация"
      }
    },
    {
      path: '/:pathMatch(.*)*', component: NotFoundPage
    }

  ],
  history: createWebHistory()
});
const DEFAULT_TITLE = 'ФРП';
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  next();
});
export default router;
